export const normalizeZipCode = (postalCode: string | null | undefined): string | null => {
  if (!postalCode) return null;
  const trimmed = postalCode.trim();
  if (!trimmed) return null;

  const five = trimmed.slice(0, 5);
  return /^\d{5}$/.test(five) ? five : null;
};
